import { Callout, Checkbox, DefaultButton, Icon, Label, SearchBox,Dropdown,Stack } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";
import { mergeStyles } from "react-select";


const CustomMultiSelectDropdown = ({
  options,
  label,
  placeholder,
  searchPlaceholder,
  styles,
  dropdownRef,
  selectedKeys,
  setSelectedKeys,
  customClassName,
  showSelectAll,
  calloutProps,
}) => {
  const containerRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const onSearchChange = (event, newValue) => {
    setSearchText(newValue || "");
  };

  const onCheckboxChange = (event, option) => {
    if (option.key === "__selectAll__") {
      if (option.selected) {
        setSelectedKeys(options.map(o => o.key));
      } else {
        setSelectedKeys([]);
      }
      return;
    }
    const newSelectedKeys = [...selectedKeys];
    if (option.selected) {
      newSelectedKeys.push(option.key);
    } else {
      const index = newSelectedKeys.indexOf(option.key);
      if (index > -1) {
        newSelectedKeys.splice(index, 1);
      }
    }
    setSelectedKeys(newSelectedKeys);
  };

  useEffect(() => {
    if (options.length > 0) {
      const tempFilteredOptions = options.filter((option) => {
        return option.text.toLowerCase().includes(searchText.toLowerCase());
      });
      setFilteredOptions(tempFilteredOptions);
    }
  }, [options, searchText]);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
      setSearchText("");
    }
  };

  if (isOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isOpen]);

  const allSelected = options.length > 0 && selectedKeys?.length === options.length;

  const renderOption = (option) => (
    <div key={option.key} className={mergeStyles({ padding: "4px 8px" })}>
      <Checkbox
        label={option.text}
        checked={selectedKeys.includes(option.key)}
        onChange={(e, checked) =>
          onCheckboxChange(e, { ...option, selected: checked })
        }
      />
    </div>
  );
const handleDropdownClick = () => {
  setIsOpen(!isOpen);
};
  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {label && <Label className={customClassName}>{label}</Label>}
      <Dropdown
        placeholder={
          selectedKeys?.length === 0
            ? placeholder
            : `Selected ${selectedKeys?.length} of ${options?.length}`
        }
        onClick={handleDropdownClick}
        selectedKey={null}
        styles={styles}
        onRenderTitle={() => console.log("hi title is getting rendered")}
        onRenderContainer={({ calloutProps }) => (
          isOpen ? (
            <Callout {...calloutProps} target={containerRef.current} doNotLayer={true} calloutWidth={containerRef.current?.offsetWidth} onDismiss={() => { setIsOpen(false); setSearchText(""); }}>
            <div className="custom-multiselect">
              <SearchBox placeholder={searchPlaceholder || "Search options"} onChange={onSearchChange} />
              <div style={{ maxHeight: 150, overflowY: "auto" }}>
                {showSelectAll && filteredOptions.length > 0 && (
                  <div className={mergeStyles({ padding: "4px 8px", borderBottom: "1px solid #ccc" })}>
                    <Checkbox
                      label="Select All"
                      checked={allSelected}
                      onChange={(e, checked) =>
                        onCheckboxChange(e, { key: "__selectAll__", selected: checked })
                      }
                    />
                  </div>
                )}
                {filteredOptions.length > 0 ? (
                  filteredOptions.map(renderOption)
                ) : (
                  <div>No records found</div>
                )}
              </div>
            </div>
          </Callout>
          ) : null
        )}
        onRenderCaretDown={() => <Icon iconName="ChevronDown" />}
        onDismiss={() => { setIsOpen(false); setSearchText(""); }}
        componentRef={dropdownRef}
        className={customClassName}
      />
    </div>
  );
};

const CustomMultiSelect = ({
  dropdownRef,
  options,
  placeholder,
  searchPlaceholder,
  selectedKeys,
  setSelectedKeys,
  customClassName,
  label,
  showSelectAll,
  calloutProps,
}) => {
  const dropdownStyles = {
    dropdown: {
      width: "100%",
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "200px",
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white",
    },
  };

  return (
    <Stack tokens={{ childrenGap: 20 }}>
      <CustomMultiSelectDropdown
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        label={label}
        options={options}
        styles={dropdownStyles}
        dropdownRef={dropdownRef}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        customClassName={customClassName}
        showSelectAll={showSelectAll}
        calloutProps={calloutProps}
      />
    </Stack>
  );
};
export default CustomMultiSelect;